import { render, staticRenderFns } from "./SettledHead.vue?vue&type=template&id=5676bc02&scoped=true&"
import script from "./SettledHead.vue?vue&type=script&lang=js&"
export * from "./SettledHead.vue?vue&type=script&lang=js&"
import style0 from "./SettledHead.vue?vue&type=style&index=0&id=5676bc02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5676bc02",
  null
  
)

export default component.exports